// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"8206d732","386":"d6c7cc40","806":"4e175f4a"}[chunkId] + ".chunk.js";
};